import React from "react";

import logo from "../../assets/svgs/avatr/avatr-wordmark.svg";
import next from "../../assets/svgs/avatr/chevron-right.svg";
import previous from "../../assets/svgs/avatr/chevron-left.svg";
import { CarsData } from "../../data/cars.data";
import BrowserInfo from '../helpers/BrowserInfo';

interface CarouselComponentProps {
  isPortrait: boolean;
  showCarousel: boolean;
  introLoaded: boolean;
  setSelectedCar: (value: any) => void;
  setProgress: (value: number) => void;
  setIntroLoaded: (value: boolean) => void;
  enableTouchScreen: () => void;
}

const CarouselComponent: React.FC<CarouselComponentProps> = ({ isPortrait, showCarousel, introLoaded, setSelectedCar, setProgress, setIntroLoaded, enableTouchScreen }) => {

  const browserInfo = BrowserInfo();
  //browserInfo.isDeviceMobile
  const [nextCar, setNextCar] = React.useState<any>([]);
  const [previousCar, setPreviousCar] = React.useState<any>([]);
  const [carList, setCarList] = React.useState<any>([]);
  const [carIndex, setCarIndex] = React.useState(0);
  const [switchFocus, setSwitchFocus] = React.useState(false);
  const [loadedCount, setLoadedCount] = React.useState(0);
  const [slideDirection, setSlideDirection] = React.useState(-1);
  
  React.useEffect(() => {
    if(carList.length > 0) //para asegurar que solo se ejecute una vez, ya que depende de una función.
      return;
    const carsData: any = CarsData();
    const carStruct: any = [];
    let firstCar : any = null;
    for(const car of carsData){
      if(car.active === false)
        continue;
      if(!firstCar)
        firstCar = car;
      carStruct.push(car);
    }
    setSelectedCar(null);
    setPreviousCar(firstCar);
    setNextCar(firstCar);

    setCarList(carStruct);
    setCarIndex(0)
  }, [setSelectedCar, carList.length]);

  React.useEffect(() => {
    window.addEventListener('touchstart', enableTouchScreen)
    return () => {
      window.removeEventListener('touchstart', enableTouchScreen)
    };
  }, [enableTouchScreen]);

  React.useEffect(() => {
    if(carList.length > 0){
      setProgress(100 * loadedCount / carList.length)
      setIntroLoaded(loadedCount === carList.length)
    }
  }, [loadedCount, carList, setIntroLoaded, setProgress]);

  const FocusCar = (value: number) => {
    if(carIndex === value)
      return;
    setSlideDirection(carIndex > value ? 1 : -1);
    setPreviousCar(nextCar);
    setSwitchFocus(!switchFocus);
    setCarIndex(value);
    setNextCar(carList[value])
  }

  const NextCar = () => {
    let index = carIndex + 1;
    if(index > carList.length - 1)
      index = 0;
    setCarIndex(index);
    setPreviousCar(nextCar);
    setSwitchFocus(!switchFocus);
    setNextCar(carList[index])
    setSlideDirection(-1);
  }

  const PreviousCar = () => {
    let index = carIndex - 1;
    if(index < 0)
      index = carList.length - 1;
    setCarIndex(index);
    setPreviousCar(nextCar);
    setSwitchFocus(!switchFocus);
    setNextCar(carList[index])
    setSlideDirection(1);
  }

  // En vertical se usa la versión de la foto compuesta para celular, si existe
  const GetCard = (car: any) => (isPortrait && car?.cardMobile) ? car.cardMobile : car?.card;

  // Con un solo vehículo no tiene sentido mostrar flechas, indicadores ni deslizar
  const hasMultipleCars = carList.length > 1;

  const SelectCar = () => {
    setSelectedCar(nextCar)
  }

  const handleImageLoad = () => {
    setLoadedCount((prev) => prev + 1);
    setProgress(100 * (loadedCount + 1) / carList.length)
  };

  const SwipeDetector: React.FC<{ onSwipeLeft: () => void; onSwipeRight: () => void }> = ({onSwipeLeft, onSwipeRight,}) => {
    const [startX, setStartX] = React.useState<number | null>(null);
  
    const handleTouchStart = React.useCallback((e: TouchEvent) => {
      setStartX(e.touches[0].clientX);
    }, []);

    const handleTouchEnd = React.useCallback((e: TouchEvent) => {
      if (startX === null)
        return;

      const endX = e.changedTouches[0].clientX;
      const deltaX = endX - startX;
  
      const swipeThreshold = 50; // Minimum swipe distance in pixels
  
      if (deltaX < -swipeThreshold) {
        onSwipeLeft();
      } else if (deltaX > swipeThreshold) {
        onSwipeRight();
      }
  
      setStartX(null);
    }, [startX, onSwipeLeft, onSwipeRight]);

    React.useEffect(() => {
      document.addEventListener("touchstart", handleTouchStart);
      document.addEventListener("touchend", handleTouchEnd);
  
      return () => {
        document.removeEventListener("touchstart", handleTouchStart);
        document.removeEventListener("touchend", handleTouchEnd);
      };
    }, [handleTouchStart, handleTouchEnd]);
  
    return <div style={{ display: "none", width: "0px", height: "0px" }}/>;
  };

  return (
    <div className={`carousel-container ${showCarousel ? '':'hide-container'}`}>

      {/* SOLO PARA QUE CARGUE LAS IMAGENES, ESTOS DIV NO SE VEN */}
      {!introLoaded &&
        <div className={`carousel-load-only`}>
          {(carList).map((carData: any, index: number) => 
            <div key={carData.id} className={`carousel-slide`}>
              <img className={`carousel-slide-img ${isPortrait ? 'portrait':''}`} onLoad={handleImageLoad} src={GetCard(carData)} alt="" />
            </div>
          )}
        </div>
      }
      {hasMultipleCars && <SwipeDetector onSwipeLeft={() => NextCar()} onSwipeRight={() => PreviousCar()}/>}

      
      {nextCar && previousCar &&
        <div className={`carousel-info-card ${isPortrait ? 'portrait':''} ${(!isPortrait && browserInfo.isDeviceMobile) ? 'mobileland':''}`}>
          {isPortrait &&
            <div className={`carousel-seal-container ${isPortrait ? 'portrait':''} ${(!isPortrait && browserInfo.isDeviceMobile) ? 'mobileland':''}`}>
              <img className={`carousel-seal-container-img ${isPortrait ? 'portrait':''} ${(!isPortrait && browserInfo.isDeviceMobile) ? 'mobileland':''}`} src={nextCar.seal?.default || nextCar.seal} alt="" />
            </div>
          }

          {!isPortrait && <img className={`carousel-info-header ${isPortrait ? 'portrait':''}`} src={logo} alt="" />}

          <div className={`carousel-info-desc ${isPortrait ? 'portrait':''} ${(!isPortrait && browserInfo.isDeviceMobile) ? 'mobileland':''}`}>
            <div className={`carousel-info-eyebrow ${isPortrait ? 'portrait':''}`}>Showroom virtual</div>
            <div className={`carousel-info-title ${isPortrait ? 'portrait':''} ${(!isPortrait && browserInfo.isDeviceMobile) ? 'mobileland':''}`}>{nextCar.fullname}</div>
            <img className={`carousel-info-specs ${isPortrait ? 'portrait':''} ${(!isPortrait && browserInfo.isDeviceMobile) ? 'mobileland':''}`} src={nextCar.specs?.default || nextCar.specs} alt="" />

            <div className={`carousel-info-options ${isPortrait ? 'portrait':''}`}>

              <div className={`carousel-info-options-buttonnav ${isPortrait ? 'portrait':''}`}>
                <div className={`carousel-info-options-button av-btn-primary ${isPortrait ? 'portrait':''} ${(!isPortrait && browserInfo.isDeviceMobile) ? 'mobileland':''}`} onClick={() => {SelectCar()}}>
                  <div className={`carousel-info-options-button-text ${isPortrait ? 'portrait':''}`}>Explora el vehículo</div>
                </div>
                {!isPortrait && hasMultipleCars &&
                  <div className={`carousel-info-options-bullets ${isPortrait ? 'portrait':''}`}>
                    {
                      (carList).map((carData: any, index: number) => 
                        <div key={carData.id} className={`carousel-bullet-container ${nextCar.id === carData.id ? ' selected':''} ${isPortrait ? ' portrait':''} ${(!isPortrait && browserInfo.isDeviceMobile) ? 'mobileland':''}`} onClick={() => {FocusCar(index)}}>
                          <div className={`carousel-bullet ${nextCar.id === carData.id ? 'selected':''}`}/>
                        </div>
                      )
                    }
                  </div>
                }
              </div>

              {hasMultipleCars &&
                <div className={`carousel-info-options-navegation ${isPortrait ? 'portrait':''}`}>
                  <div className={`carousel-info-options-navegation-next ${isPortrait ? 'portrait':''}`} onClick={() => {PreviousCar()}}>
                    <img className={`carousel-info-options-navegation-icon ${isPortrait ? 'portrait':''}`} src={previous} alt="" />
                  </div>
                  <div className={`carousel-info-options-navegation-next ${isPortrait ? 'portrait':''}`} onClick={() => {NextCar()}}>
                    <img className={`carousel-info-options-navegation-icon ${isPortrait ? 'portrait':''}`} src={next} alt="" />
                  </div>
                </div>
              }

            </div>
            {isPortrait && hasMultipleCars &&
              <div className={`carousel-info-options-bullets ${isPortrait ? 'portrait':''}`}>
                {
                  (carList).map((carData: any, index: number) => 
                    <div key={carData.id} className={`carousel-bullet-container${nextCar.id === carData.id ? ' selected':''}${isPortrait ? ' portrait':''}`} onClick={() => {FocusCar(index)}}>
                      <div className={`carousel-bullet ${nextCar.id === carData.id ? 'selected':''}`}/>
                    </div>
                  )
                }
              </div>
            }
          </div>
        {!isPortrait && <div className={`carousel-content-footer`}/>}
      </div>}

      {nextCar && previousCar &&
        <div className={`carousel-content-image ${isPortrait ? 'portrait':''}`}>
          {nextCar && previousCar &&
            <div className={`carousel-slides ${switchFocus ? 'visible':''}`}>
              <div className={`carousel-slide-center ${!switchFocus ? '' : slideDirection > 0 ? 'right' : 'left'} ${isPortrait ? 'portrait':''}`}>
                <img className={`carousel-slide-img ${isPortrait ? 'portrait':''}`} src={GetCard(previousCar)} alt="" />
              </div>
              <div className={`carousel-slide-right ${!switchFocus ? '' : slideDirection > 0 ? '' : 'center'} ${isPortrait ? 'portrait':''}`}>
                <img className={`carousel-slide-img ${isPortrait ? 'portrait':''}`} src={GetCard(nextCar)} alt="" />
              </div>
              <div className={`carousel-slide-left ${!switchFocus ? '' : slideDirection > 0 ? 'center' : ''} ${isPortrait ? 'portrait':''}`}>
                <img className={`carousel-slide-img ${isPortrait ? 'portrait':''}`} src={GetCard(nextCar)} alt="" />
              </div>
            </div>
          }
          {nextCar && previousCar &&
            <div className={`carousel-slides ${!switchFocus ? 'visible':''}`}>
              <div className={`carousel-slide-center ${switchFocus ? '' : slideDirection > 0 ? 'right' : 'left'} ${isPortrait ? 'portrait':''}`}>
                <img className={`carousel-slide-img ${isPortrait ? 'portrait':''}`} src={GetCard(previousCar)} alt="" />
              </div>
              <div className={`carousel-slide-right ${switchFocus ? '' : slideDirection > 0 ? '' : 'center'} ${isPortrait ? 'portrait':''}`}>
                <img className={`carousel-slide-img ${isPortrait ? 'portrait':''}`} src={GetCard(nextCar)} alt="" />
              </div>
              <div className={`carousel-slide-left ${switchFocus ? '' : slideDirection > 0 ? 'center' : ''} ${isPortrait ? 'portrait':''}`}>
                <img className={`carousel-slide-img ${isPortrait ? 'portrait':''}`} src={GetCard(nextCar)} alt="" />
              </div>
            </div>
          }
          {isPortrait && <img className={`carousel-portrait-logo`} src={logo} alt="" />}
          {!isPortrait &&
            <div className={`carousel-seal-container ${isPortrait ? 'portrait':''} ${(!isPortrait && browserInfo.isDeviceMobile) ? 'mobileland':''}`}>
              <img className={`carousel-seal-container-img ${isPortrait ? 'portrait':''} ${(!isPortrait && browserInfo.isDeviceMobile) ? 'mobileland':''}`} src={nextCar.seal?.default || nextCar.seal} alt="" />
            </div>
          }
          
        </div>
      }
      
    </div>
  );
};

export default CarouselComponent;